import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import ammy from "./Homepage.module.css";
import logo from "./image/kids.png";
import slide1 from "./image/im.1.jpg";
import slide2 from "./image/im.2.jpg";
import slide3 from "./image/im.3.jpeg";

import axios from "axios";

export default function Homepage() {
  const sliderRef = useRef(null);
  const [category, setCategory] = useState([]);
  const [video, setvideo] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawingvideo, setDrawingvideo]= useState([]);
  const [learningvideo, setLearningvideo]= useState([]);
    const [Rhymesvideo, setRhymesvideo]= useState([]);
  const [Storiesvideo, setStoriesvideo]= useState([]);


  console.log(drawingvideo,"jjjjjjjjjcatrtt")
  const slides = [slide1, slide2, slide3];

  const scrollSlider = (direction) => {
    if (sliderRef.current) {
      const width = sliderRef.current.clientWidth;
      sliderRef.current.scrollBy({
        left: direction * width,
        behavior: "smooth",
      });
    }
  };

  async function fetchfuc() {
    const response = await axios.get(
      "https://ke-kiddzmania.rashigames.com/api/fetch-product"
    );
    console.log(response.data);
    setCategory(response.data.categories);
    setvideo(response.data.videos);
    setDrawingvideo(response.data.videos.filter((v)=>v.category_id==1))
    setLearningvideo(response.data.videos.filter((v)=>v.category_id==2))
    setRhymesvideo(response.data.videos.filter((v)=>v.category_id==3))
    setStoriesvideo(response.data.videos.filter((v)=>v.category_id==4))
    
    console.log(setCategory(response.data.categories));
  }

  useEffect(() => {
    fetchfuc();
  }, []);

  return (
    <div className={ammy.container}>
      <header className={ammy.header}>
        <nav className={ammy.nav}>
          <div className={ammy.dropdown} onClick={() => setOpen(!open)}>
            <span className={ammy.dropTitle}>Category </span>

            {open && (
              <ul className={ammy.menu}>
                {category.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.id}`}
                      className={ammy.categoryLink}
                      onClick={() => setOpen(false)}
                    >
                      {cat.category}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className={ammy.logo}>
            <img src={logo} alt="kids_mania" />
          </div>

          <Link to="/">
            <button className={ammy.btn}>LOG OUT</button>
          </Link>
        </nav>
      </header>

      <section className={ammy.hero}>
        <h1>Welcome to Kids Mania 🎉</h1>
        <p>Fun • Learning • Stories • Rhymes</p>

        <div className={ammy.slider}>
          <button className={ammy.arrowLeft} onClick={() => scrollSlider(-1)}>
            ‹
          </button>

          <div className={ammy.slideTrack} ref={sliderRef}>
            {slides.map((img, idx) => (
              <img key={idx} src={img} alt={`slide-${idx + 1}`} />
            ))}
          </div>

          <button className={ammy.arrowRight} onClick={() => scrollSlider(1)}>
            ›
          </button>
        </div>
      </section>

      <section className={ammy.videos}>
        <div key={1} className={ammy.videoCard}>
            <ReactPlayer
              src={drawingvideo[0]?.video_src}
              controls
              width="250px"
              height="150px"
            />
            <h4 className={ammy.videoTitle}>Drawing</h4>
            <Link to={`/video/${drawingvideo[0]?.id}`}>
              <button className={ammy.watchBtn}>Watch</button>
            </Link>
          </div>
          <div key={2} className={ammy.videoCard}>
            <ReactPlayer
              src={learningvideo[0]?.video_src}
              controls
              width="250px"
              height="150px"
            />
            <h4 className={ammy.videoTitle}>Learning</h4>
            <Link to={`/video/${learningvideo[0]?.id}`}>
              <button className={ammy.watchBtn}>Watch</button>
            </Link>
          </div>
          <div key={3} className={ammy.videoCard}>
            <ReactPlayer
              src={Rhymesvideo[0]?.video_src}
              controls
              width="250px"
              height="150px"
            />
            <h4 className={ammy.videoTitle}>Rhymes</h4>
            <Link to={`/video/${Rhymesvideo[0]?.id}`}>
              <button className={ammy.watchBtn}>Watch</button>
            </Link>
          </div>
          <div key={4} className={ammy.videoCard}>
            <ReactPlayer
              src={Storiesvideo[0]?.video_src}
              controls
              width="250px"
              height="150px"
            />
            <h4 className={ammy.videoTitle}>Stories</h4>
            <Link to={`/video/${Storiesvideo[0]?.id}`}>
              <button className={ammy.watchBtn}>Watch</button>
            </Link>
          </div>
      </section>

      <footer className={ammy.footer}>
        <h3>Kids Mania</h3>
        <p>Safe & Fun Learning Platform for Kids </p>
        <p>© 2025 Kids Mania | All Rights Reserved</p>
      </footer>
    </div>
  );
}
